var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3761 16.484L14.1083 12.2162C14.0275 12.1353 13.922 12.0932 13.8095 12.0932H13.3455C14.4528 10.81 15.1243 9.14018 15.1243 7.31214C15.1243 3.27289 11.8514 0 7.81214 0C3.77289 0 0.5 3.27289 0.5 7.31214C0.5 11.3514 3.77289 14.6243 7.81214 14.6243C9.64018 14.6243 11.31 13.9528 12.5932 12.8455V13.3095C12.5932 13.422 12.6389 13.5275 12.7162 13.6083L16.984 17.8761C17.1492 18.0413 17.4164 18.0413 17.5816 17.8761L18.3761 17.0816C18.5413 16.9164 18.5413 16.6492 18.3761 16.484ZM7.81214 12.9369C4.70448 12.9369 2.18742 10.4198 2.18742 7.31214C2.18742 4.20448 4.70448 1.68742 7.81214 1.68742C10.9198 1.68742 13.4369 4.20448 13.4369 7.31214C13.4369 10.4198 10.9198 12.9369 7.81214 12.9369Z",
    fill: "#777777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.78625272.svg";
export { ForwardRef as ReactComponent };